module.exports = __webpack_public_path__ + "static/media/IMG_1452.291e6d8c.PNG";